
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/student-profile",
      function () {
        return require("private-next-pages/student/student-profile/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/student-profile"])
      });
    }
  